<template>
  <v-layout row wrap>
    <v-flex xs12>
      <template v-if="isLoading">
        <Loading />
      </template>
      <template v-else-if="hasDbError">
        <Error v-for="(error, key) in dbErrors" v-if="error" :key="key" error="error" />
      </template>
      <template v-else>
        <div>
          <v-btn flat color="primary" @click="goWeekMatches">
            {{ $t('page.match.returnClub') }}
          </v-btn>
        </div>
        <v-container fluid grid-list-md pa-0>
          <MatchCard
            :current-user="currentUser"
            :match="match"
            :club="club"
            :sport="sport"
            :admin-mode="isClubAdmin"
            :editor-mode="isClubEditor"
            :viewer-mode="isClubViewer"
            :logged-mode="isLoggedUser"
            :hidde-details="true"
            :display-sets="true"
            :display-stats="true"
            :display-charts="true"
            :display-comments="true"
            @onUpdate="onUpdateMatch"
            @onAddPlayer="onAddPlayer"
            @onSendEvent="onSendEvent"
            @onToogleBlockMatch="onToogleBlockMatch"
            @onRemoveLastEvent="onRemoveLastEvent"
            @onAddComment="onAddComment"
            @onRemoveComment="onRemoveComment"
            @onDeleteMatch="onDeleteMatch"
          />
        </v-container>
        <Sponsors
          v-if="clubSponsors && clubSponsors.length > 0"
          :sponsors="clubSponsors"
          class="mt-3"
        />
        <div>
          <v-btn flat color="primary" @click="goWeekMatches">
            {{ $t('page.match.returnClub') }}
          </v-btn>
        </div>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash'
import ClubsLib from '@/lib/data/clubs'
import MatchesLib from '@/lib/data/matches'
import ClubUsersLib from '@/lib/data/clubUsers'
import ClubSponsorsLib from '@/lib/data/clubSponsors'
import SecurityHelper from '@/lib/SecurityHelper'
import SportHelper from '@/lib/SportHelper'
import MatchCard from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard'
import Sponsors from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/Sponsors'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
import MetaHelper from '@/lib/MetaHelper'
const debug = require('debug')('OD::Match')

export default {
  name: 'Match',
  components: { MatchCard, Sponsors, Loading, Error },
  mixins: [BaseMixin],
  props: {
    clubId: {
      type: String,
      required: true,
    },
    year: {
      type: String,
      required: true,
    },
    week: {
      type: String,
      required: true,
    },
    matchId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      club: {},
      match: {},
      clubUsers: [],
      clubSponsors: [],
      loadings: {
        club: true,
        match: true,
        clubUsers: true,
        clubSponsors: true,
      },
      dbErrors: {
        club: null,
        match: null,
        clubusers: null,
        clubSponsors: null,
      },
    }
  },
  computed: {
    isLoggedUser(currentUser) {
      return SecurityHelper.isLoggedUser(this.currentUser)
    },
    isClubAdmin(currentUser, clubUsers, clubId) {
      return SecurityHelper.isClubAdmin(this.currentUser, this.clubUsers, this.clubId)
    },
    isClubEditor(currentUser, clubusers, clubId) {
      return SecurityHelper.isClubEditor(this.currentUser, this.clubUsers, this.clubId)
    },
    isClubViewer(currentUser, clubusers, clubId) {
      return SecurityHelper.isClubViewer(this.currentUser, this.clubUsers, this.clubId)
    },
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    sport() {
      if (this.match && this.match.sport) return SportHelper.getSportConfiguration(this.match.sport)
      return SportHelper.getSportConfiguration(this.club.sport)
    },
  },
  watch: {
    clubId() {
      this.bind()
    },
    year() {
      this.bind()
    },
    week() {
      this.bind()
    },
    matchId() {
      this.bind()
    },
    club() {
      if (this.club) {
        this.$emit('updateHead')
      }
    },
  },
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  methods: {
    bind() {
      ClubsLib.bindItem(this, { clubId: this.clubId })
      ClubUsersLib.bindAll(this, { clubId: this.clubId })
      ClubSponsorsLib.bindAll(this, { clubId: this.clubId })
      MatchesLib.bindItem(this, {
        clubId: this.clubId,
        year: this.year,
        week: this.week,
        matchId: this.matchId,
      })
    },
    goWeekMatches() {
      this.navigateTo({
        name: 'WeekMatches',
        params: {
          clubId: this.clubId,
          year: this.year,
          week: this.week,
        },
      })
    },
    async onUpdateMatch(newItem, item) {
      debug('onUpdateMatch', newItem, item)
      await MatchesLib.update(this, this.currentUser, this.club, this.sport, item, newItem)
    },
    async onAddPlayer(data) {
      await MatchesLib.addPlayer(this, this.currentUser, this.club, this.sport, data)
    },
    async onSendEvent(data) {
      await MatchesLib.sendEvent(this, this.currentUser, this.club, this.sport, data)
    },
    async onRemoveLastEvent(data) {
      await MatchesLib.removeLastEvent(this, this.currentUser, this.club, this.sport, data)
    },
    async onToogleBlockMatch(data) {
      await MatchesLib.toogleBlockMatch(this, this.currentUser, this.club, this.sport, data)
    },
    async onAddComment(data) {
      await MatchesLib.addComment(this, this.currentUser, this.club, this.sport, data)
    },
    async onRemoveComment(data) {
      await MatchesLib.removeComment(this, this.currentUser, this.club, this.sport, data)
    },
    async onDeleteMatch(item) {
      debug('onDeleteMatch', item)
      await MatchesLib.delete(this, this.currentUser, item)
      this.goWeekMatches()
    },
  },
  head: {
    title: function() {
      return MetaHelper.getClubTitle(this.clubId, this.club, 'weekMatches')
    },
    meta: function() {
      return MetaHelper.getClubMeta(this.clubId, this.club, 'weekMatches', {
        name: 'WeekMatches',
        params: { clubId: this.clubId, year: this.year, week: this.week },
      })
    },
  },
}
</script>

<style lang="scss">
</style>
